import { Component } from '@angular/core';
import * as L from 'leaflet';
import { latLng, Map, MapOptions } from 'leaflet';

declare var sanitarySurveys: any;
declare function ObjectFitCoverFix(): any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  markers = [];
  data = sanitarySurveys.data;
  filtered = [];
  area: string = sanitarySurveys.area;
  queryValue: string;
  page = 1;
  paged = [];
  totalpages = 1;
  map: Map;
  height = 600;

  osm: L.TileLayer.WMS = L.tileLayer.wms('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  });

  myLatlng: L.LatLng;

  options: MapOptions = {
    zoom: 6,
    zoomControl: true,
    minZoom: 2,
    center: latLng(56.5, -4.0)
  };

  constructor() {
    this.myLatlng = (this.area.indexOf('Scotland') >= 0)
      ? new L.LatLng(58, -3.5)
      : new L.LatLng(53, -1.3);
  }

  onMapReady(map: Map) {
    this.map = map;
    this.map.panTo(this.myLatlng, { animate: false, duration: 0 });
    this.map.addLayer(this.osm);

    setTimeout(() => {
      this.map.invalidateSize();
    }, 0);

    // reset location
    if (sessionStorage.getItem('sanitarySurveys-' + this.area)) {
      try {
        const view = JSON.parse(sessionStorage.getItem('sanitarySurveys-' + this.area));
        this.map.setView(L.latLng(view.lat, view.lng), view.zoom);
      } catch (e) {
        console.log('Unable to parse saved location', e);
      }
    }
    this.addmarkers(this.data);

    this.filtered = [];
    for (const x of this.data) {
      this.filtered.push(x);
    }
    this.page = 1;
    this.totalpages = Math.ceil(this.filtered.length / 12);
    for (let i = 0; i < 12; i++) {
      if (i < this.filtered.length) {
        this.paged.push(this.filtered[i]);
      }
    }

    this.map.on('moveend', () => {
      this.save();
    });

    ObjectFitCoverFix();
  }

  addmarkers(markers: any) {
    this.save();
    for (const m of markers) {
      const doc = m.url;
      const html = '<div class="info-blob">' + m.pageTitle + '<br />' + m.localAuthority +
        '<br /><a href="' + doc + '" target="blank">' + doc.split('/').pop() + '</div>';
      const myLatlng = new L.LatLng(m.latitude, m.longitude);
      const marker = new L.Marker(myLatlng);
      marker.bindPopup(html);
      this.map.addLayer(marker);
      this.markers.push(marker);
    }
  }

  search() {
    this.filtered = [];
    for (const d of this.data) {
      if (d.length === 0 || d.pageTitle.toLowerCase().indexOf(this.queryValue.toLowerCase()) >= 0
        || d.localAuthority.toLowerCase().indexOf(this.queryValue.toLowerCase()) >= 0) {
        this.filtered.push(d);
      }
    }
    this.page = 1;
    this.totalpages = Math.ceil(this.filtered.length / 12);
    this.paged = [];
    for (let i = 0; i < 12; i++) {
      if (i < this.filtered.length) {
        this.paged.push(this.filtered[i]);
      }
    }
  }

  save() {
    const view = {
      lat: this.map.getCenter().lat,
      lng: this.map.getCenter().lng,
      zoom: this.map.getZoom()
    };
    sessionStorage.setItem('sanitarySurveys-' + this.area, JSON.stringify(view));
  }

  pageChanged(p: number) {
    this.page = p;
    this.paged = [];
    for (let i = (this.page - 1) * 12; i < this.page * 12; i++) {
      if (i < this.filtered.length) {
        this.paged.push(this.filtered[i]);
      }
    }
    ObjectFitCoverFix();
  }
}
